<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!--            <a-col :md="8" :sm="24">
              <a-form-item label="原订单id user_user.id" prop="oriOrderId">
                <a-input v-model="queryParam.oriOrderId" placeholder="请输入原订单id user_user.id" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称" prop="nickName">
                <a-input v-model="queryParam.nickName" placeholder="请输入用户名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="退款状态" prop="refundStatus">
                <a-select placeholder="请选择标签" style="width: 100%" v-model="queryParam.refundStatus" allowClear>
                  <a-select-option
                    v-for="(item, index) in this.customDict.orderRefundtatusEnum"
                    :value="item.type"
                    :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!--              <a-col :md="8" :sm="24">
                <a-form-item label="用户id user_user.id" prop="userId">
                  <a-input v-model="queryParam.userId" placeholder="请输入用户id user_user.id" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="用户名称" prop="nickName">
                  <a-input v-model="queryParam.nickName" placeholder="请输入用户名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="店铺id user_user.id" prop="shopId">
                  <a-input v-model="queryParam.shopId" placeholder="请输入店铺id user_user.id" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="店铺名称" prop="shopName">
                  <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="退款金额" prop="refundAmount">
                  <a-input v-model="queryParam.refundAmount" placeholder="请输入退款金额" allow-clear/>
                </a-form-item>
              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:order/refund:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['order:order/refund:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:order/refund:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['order:order/refund:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="playTime" slot-scope="text, record">
          {{ parseTime(record.playTime) }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['order:order/refund:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:order/refund:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['order:order/refund:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:order/refund:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
        <span slot="refundStatus" slot-scope="text, record">
          <!-- 重写自定义了个字典组件（标签）-->
          <custom-dict-tag :options="customDict.orderRefundtatusEnum" :value="record.refundStatus"/>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listOrderRefund, delOrderRefund } from '@/api/order/orderRefund'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
export default {
  name: 'OrderRefund',
  components: {
    CreateForm,
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: null,
        oriOrderId: null,
        userId: null,
        nickName: null,
        shopId: null,
        shopName: null,
        refundAmount: null,
        refundStatus: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /* {
          title: 'id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单类型 21.打本订单(order_order_script)',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '原订单id user_user.id',
          dataIndex: 'oriOrderId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户id user_user.id',
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户名称',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
       /* {
          title: '店铺id user_user.id',
          dataIndex: 'shopId',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: '退款金额',
          dataIndex: 'refundAmount',
          ellipsis: true,
          width: 80,
          align: 'center'
        },
        {
          title: '退款状态',
          dataIndex: 'refundStatus',
          scopedSlots: { customRender: 'refundStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '玩本时间',
          dataIndex: 'playTime',
          scopedSlots: { customRender: 'playTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '下单时间',
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '退款原因',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: { ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    /** 查询订单-退款订单列表 */
    getList () {
      this.loading = true
      listOrderRefund(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        oriOrderId: undefined,
        userId: undefined,
        nickName: undefined,
        shopId: undefined,
        shopName: undefined,
        refundAmount: undefined,
        refundStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delOrderRefund(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('order/order/refund/export', {
            ...that.queryParam
          }, `order/refund_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
